import { getDictPhrase } from "../../../common";
export const getBetTitleYourBetProps = (bet, state) => {
    return {
        name: getDictPhrase(state.dict, "YourBet"),
        odds: bet.displayOdds
    };
};
//# sourceMappingURL=getBetTitleYourBetProps.js.map